import {formatterNum} from '../utils';

export default function (el, binding, vNode) {
  const bindValue = binding.value;
  const ele = el.tagName === 'INPUT' ? el : el.querySelector('input');
  let val = '';
  if (vNode.data && vNode.data.model) {
    val = vNode.data.model.value;
  } else {
    val = ele.value;
  }
  val = formatterNum(val, bindValue && bindValue.num);
  ele.value = val;
  ele.dispatchEvent(new Event('input'));
}

